export const participantInfo = (participatnsArr, userId) => {
  let participant = null,
    participantId = null,
    participantName = null;

  try {
    participant =
      participatnsArr[0].id === userId
        ? participatnsArr[1]
        : participatnsArr[0];

    participantId = participant.id;

    participantName = participant.name;
  } catch {
    participant = participatnsArr[0];

    participantId = participant.id;

    participantName = participant.name;
  }

  return { participantId, participantName };
};
